/**
* Handling of file upload forms in the merchant backoffice
*/
KMVP.merchantbackofficeFileUpload = {

    /**
     * Display the filename of the upload file
     * @param context Parent form element
     */
    setFilename: function(context) {
        var filename = $(context).find('.js-file-upload-input').val().split('\\').pop();
        $(context).find('.js-upload-filename').html(filename);
    },

    /**
     * Resets file input and the display of the filename
     * @param context Parent form element
     */
    resetFile: function(context) {
        $(context).find('.js-file-upload-input').val('');
        $(context).find('.js-upload-filename').html('');
    },

    /**
     * Enable a button (add disabled attribute)
     * @param context Parent form element
     * @param selector Selector of the element to enable
     */
    enable: function(context, selector) {
        $(context).find(selector).prop('disabled', false);
    },

    /**
     * Disable a button (remove disabled attribute)
     * @param context Parent form element
     * @param selector Selector of the element to disable
     */
    disable: function(context, selector) {
        $(context).find(selector).prop('disabled', true);
    },

    /**
     * Show an element (remove the 'hide' class)
     * @param context Parent form element
     * @param selector Selector of the element to show
     */
    show: function(context, selector) {
        $(context).find(selector).removeClass('hide');
    },

    /**
     * Hide an element (add the 'hide' class)
     * @param context Parent form element
     * @param selector Selector of the element to hide
     */
    hide: function(context, selector) {
        $(context).find(selector).addClass('hide');
    },


    prepareInputFields: function () {
        if ($('body').hasClass('page-merchantBackofficeCatalogBMECatImageUploadPage') ||
            $('body').hasClass('page-merchantBackofficeCatalogBMECatProductUploadPage') ||
            $('body').hasClass('page-merchantBackofficePriceImportPage') ||
            $('body').hasClass('page-merchantBackofficeCatalogStockUploadPage') ||
            $('body').hasClass('page-merchantBackofficeCustomerImportPage') ||
            $('body').hasClass('page-merchantBackofficeTransportationCostPage')) {

            $('.js-file-upload-input').on('change', function () {
                var cntxt = $(this).parents('form');
                KMVP.merchantbackofficeFileUpload.setFilename(cntxt);
                KMVP.merchantbackofficeFileUpload.enable(cntxt, '.js-file-upload-submit');
                KMVP.merchantbackofficeFileUpload.show(cntxt, '.js-upload-file-name-remove');
                KMVP.merchantbackofficeFileUpload.hideFileUploadMessage();

                if ($('body').hasClass('page-merchantBackofficePriceImportPage')) {
                    $('.js-replace-prices-container').removeClass('hide');
                }
            });

            $('.js-upload-file-name-remove').on('click', function (e) {
                e.preventDefault();
                var cntxt = $(this).parents('form');
                KMVP.merchantbackofficeFileUpload.resetFile(cntxt);
                KMVP.merchantbackofficeFileUpload.hide(cntxt, '.js-upload-file-name-remove');
                KMVP.merchantbackofficeFileUpload.disable(cntxt, '.js-file-upload-submit');
            });
        }
    },


    init: function () {
        var XHR = new window.XMLHttpRequest();

        $('.js-file-upload-submit').click(function(e) {
            e.preventDefault();
            var cntxt = $(this).parents('form');

            KMVP.merchantbackofficeFileUpload.show(cntxt, '.js-file-upload-progress');
            KMVP.merchantbackofficeFileUpload.show(cntxt, '.js-file-upload-abort');

            var url = cntxt.attr('action');
            var fileList = cntxt.find('.js-file-upload-input').prop("files");
            var replaceStatus = $(".js-file-upload-replacePrices").is(":checked");
            var file = fileList[0];
            var filename = file.name;
            var fileSectionRefreshUrl = $(this).data("filesectionrefreshurl");
            var refreshPosition = $(this).data("position");

            var formData = new FormData();

            formData.append("file", file);
            formData.append("replaceExistingPrices", replaceStatus);

            $.ajax({
                beforeSend: function() {
                    cntxt.find('.progress-bar').val(0);
                },
                xhr: function() {
                    XHR.upload.addEventListener('progress', function(e) {
                        if (e.lengthComputable) {
                            var percentComplete = Math.round(e.loaded / e.total * 100);
                            cntxt.find('.progress-bar').val(percentComplete);
                            cntxt.find('.progress-percent').html(percentComplete + "%");
                        }
                    }, false);

                    return XHR;
                },
                type: 'POST',
                url: url,
                processData: false,
                contentType: false,
                data: formData,
                success: function(data) {
                    // hide/disable non required elements
                    KMVP.merchantbackofficeFileUpload.hide(cntxt, '.js-file-upload-abort');
                    KMVP.merchantbackofficeFileUpload.hide(cntxt, '.js-file-upload-progress');
                    KMVP.merchantbackofficeFileUpload.hide(cntxt, '.js-upload-file-name-remove');
                    KMVP.merchantbackofficeFileUpload.resetFile(cntxt);
                    KMVP.merchantbackofficeFileUpload.disable(cntxt, '.js-file-upload-submit');

                    if ($('body').hasClass('page-merchantBackofficePriceImportPage')) {
                        $('.js-replace-prices-container').addClass('hide');
                    }

                    var globalMessage = data;
                    if ($(globalMessage).is('div')) {
                        if ($(globalMessage).hasClass('negative')) {
                            KMVP.merchantbackofficeFileUpload.showFileUploadMessage("alert", filename);
                        } else if ($(globalMessage).hasClass('positive')) {
                            KMVP.merchantbackofficeFileUpload.showFileUploadMessage("success", filename);
                            // reload uploaded files section
                            KMVP.merchantbackofficeFileUpload.updateFilesSection(fileSectionRefreshUrl, refreshPosition);
                        };

                        // show messages
                        $('#globalMessages').html(globalMessage);
                    }

                }
            }).fail(function(){
                KMVP.merchantbackofficeFileUpload.hide(cntxt, '.js-file-upload-abort');
                KMVP.merchantbackofficeFileUpload.hide(cntxt, '.js-file-upload-progress');
                KMVP.merchantbackofficeFileUpload.hide(cntxt, '.js-upload-file-name-remove');
                KMVP.merchantbackofficeFileUpload.resetFile(cntxt);
                KMVP.merchantbackofficeFileUpload.disable(cntxt, '.js-file-upload-submit');
                if (XHR.readyState === XMLHttpRequest.DONE) {
                    KMVP.merchantbackofficeFileUpload.showFileUploadMessage("abort", filename);
                }
            });
        });

        $('.js-file-upload-abort').on('click', function(){
            XHR.abort();
        });
    },

    updateFilesSection: function(url, positionclass) {

        $.get(url, function (data) {
            $(".js-files-section-container." + positionclass).html(data);
            $(".js-files-section-wrapper." + positionclass).removeClass('hide');
            }
        );
    },

    showFileUploadMessage: function(status, filename) {
        if (status === "abort") {
            $('.js-file-upload-message-abort .js-file-upload-message-filename').html(filename);
            $('.js-file-upload-message-abort').removeClass('hide');
        } else if (status === "success") {
            $('.js-file-upload-message-success .js-file-upload-message-filename').html(filename);
            $('.js-file-upload-message-success').removeClass('hide');
        } else if (status === "alert") {
            $('.js-file-upload-message-alert .js-file-upload-message-filename').html(filename);
            $('.js-file-upload-message-alert').removeClass('hide');
        }
    },

    hideFileUploadMessage: function() {
        $('.js-file-upload-message-abort').addClass('hide');
        $('.js-file-upload-message-abort .js-file-upload-message-filename').html('');
        $('.js-file-upload-message-success').addClass('hide');
        $('.js-file-upload-message-success .js-file-upload-message-filename').html('');
        $('.js-file-upload-message-alert').addClass('hide');
        $('.js-file-upload-message-alert .js-file-upload-message-filename').html('');
    }
}

$(document).ready(function () {
    KMVP.merchantbackofficeFileUpload.prepareInputFields();
    KMVP.merchantbackofficeFileUpload.init();
});